module.exports = __webpack_public_path__ + "img/healthcare_item.a0ad95e3.png";